// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select-module__font-s-10___NZKoy {
  font-size: 10px !important;
}

.Select-module__font-s-12___a7FpE {
  font-size: 12px !important;
}

.Select-module__font-s-13___odC2j {
  font-size: 13px !important;
}

.Select-module__font-s-14___jaVYb {
  font-size: 14px !important;
}

.Select-module__font-s-15___oqo11 {
  font-size: 15px !important;
}

.Select-module__font-s-16___U8Cx_ {
  font-size: 16px !important;
}

.Select-module__font-s-18___vWhF4 {
  font-size: 18px !important;
}

.Select-module__font-s-20___oBHmc {
  font-size: 20px !important;
}

.Select-module__font-s-22___IRuTh {
  font-size: 22px !important;
}

.Select-module__font-s-28___MTH6y {
  font-size: 28px !important;
}

.Select-module__font-w-400___mn0YZ {
  font-weight: 400 !important;
}

.Select-module__font-w-500___LfKUQ {
  font-weight: 500 !important;
}

.Select-module__font-w-600___TSBGl {
  font-weight: 600 !important;
}

.Select-module__font-w-700___G8ML_ {
  font-weight: 700 !important;
}

.Select-module__p-5___XksNn {
  padding: 5px !important;
}

.Select-module__p-12___seV6d {
  padding: 12px !important;
}

.Select-module__p-16___XyNiq {
  padding: 16px !important;
}

.Select-module__p-30___b2Lid {
  padding: 30px !important;
}

.Select-module__p-b-0___TKzyB {
  padding-bottom: 0 !important;
}

.Select-module__p-b-5___ymbg7 {
  padding-bottom: 5px !important;
}

.Select-module__p-b-10___W8ujb {
  padding-bottom: 10px !important;
}

.Select-module__p-b-12___Hj9HV {
  padding-bottom: 12px !important;
}

.Select-module__p-b-16___eJcYR {
  padding-bottom: 16px !important;
}

.Select-module__p-b-18___bZOTt {
  padding-bottom: 18px !important;
}

.Select-module__p-b-20___P6JtO {
  padding-bottom: 20px !important;
}

.Select-module__p-b-25___Iy1qY {
  padding-bottom: 25px !important;
}

.Select-module__p-b-30___jpQJl {
  padding-bottom: 30px !important;
}

.Select-module__p-b-50___Yg25Z {
  padding-bottom: 50px !important;
}

.Select-module__p-t-0___WoirW {
  padding-top: 0 !important;
}

.Select-module__p-t-12___C8tL_ {
  padding-top: 12px !important;
}

.Select-module__p-t-16___TQoxI {
  padding-top: 16px !important;
}

.Select-module__p-t-18___malJ4 {
  padding-top: 18px !important;
}

.Select-module__p-t-20___jeOFc {
  padding-top: 20px !important;
}

.Select-module__p-t-30___ZvG1R {
  padding-top: 30px !important;
}

.Select-module__p-t-40___QXB76 {
  padding-top: 40px !important;
}

.Select-module__p-t-50___X3RcM {
  padding-top: 50px !important;
}

.Select-module__p-l-20___Hwk_M {
  padding-left: 20px !important;
}

.Select-module__p-l-30___kT7fe {
  padding-left: 30px !important;
}

.Select-module__p-l-40___L5EVT {
  padding-left: 40px !important;
}

.Select-module__p-r-16___gzgVU {
  padding-right: 16px !important;
}

.Select-module__p-r-20___C3C09 {
  padding-right: 20px !important;
}

.Select-module__p-r-30___ZbnDQ {
  padding-right: 30px !important;
}

.Select-module__p-r-50___oH9iK {
  padding-right: 50px !important;
}

.Select-module__p-r-60___wqSZ4 {
  padding-right: 60px !important;
}

.Select-module__m-b-1___Pi158 {
  margin-bottom: 1px !important;
}

.Select-module__m-b-2___g_izc {
  margin-bottom: 2px !important;
}

.Select-module__m-b-6___cTmcU {
  margin-bottom: 6px !important;
}

.Select-module__m-b-8___fRPEZ {
  margin-bottom: 8px !important;
}

.Select-module__m-b-10___arBXw {
  margin-bottom: 10px !important;
}

.Select-module__m-b-14___Z8Vcb {
  margin-bottom: 14px !important;
}

.Select-module__m-b-16___Do7tN {
  margin-bottom: 16px !important;
}

.Select-module__m-b-20___BnUDs {
  margin-bottom: 20px !important;
}

.Select-module__m-b-22___qdupk {
  margin-bottom: 22px !important;
}

.Select-module__m-b-24___cWXqq {
  margin-bottom: 24px !important;
}

.Select-module__m-b-30___ViFAO {
  margin-bottom: 30px !important;
}

.Select-module__m-b-32___HFWSZ {
  margin-bottom: 32px !important;
}

.Select-module__m-b-40___wfaIB {
  margin-bottom: 40px !important;
}

.Select-module__m-t-2___wSrLW {
  margin-top: 2px !important;
}

.Select-module__m-t-3___qd9SJ {
  margin-top: 3px !important;
}

.Select-module__m-t-4___sXtuy {
  margin-top: 4px !important;
}

.Select-module__m-t-5___BDSnI {
  margin-top: 5px !important;
}

.Select-module__m-t-8___jeOx2 {
  margin-top: 8px !important;
}

.Select-module__m-t-10___NMVKA {
  margin-top: 10px !important;
}

.Select-module__m-t-15___DPqay {
  margin-top: 15px !important;
}

.Select-module__m-t-16___AbgxD {
  margin-top: 16px !important;
}

.Select-module__m-t-20___LmzIt {
  margin-top: 20px !important;
}

.Select-module__m-t-22___O_5yz {
  margin-top: 22px !important;
}

.Select-module__m-t-30____wm9g {
  margin-top: 30px !important;
}

.Select-module__m-t-32___r3hPI {
  margin-top: 32px !important;
}

.Select-module__m-l-auto___uFjoO {
  margin-left: auto !important;
}

.Select-module__m-l-4___eJxsY {
  margin-left: 4px !important;
}

.Select-module__m-l-5___GGpHB {
  margin-left: 5px !important;
}

.Select-module__m-l-6___PS8QK {
  margin-left: 6px !important;
}

.Select-module__m-l-8___XuW1m {
  margin-left: 8px !important;
}

.Select-module__m-l-10___pgOD7 {
  margin-left: 10px !important;
}

.Select-module__m-l-16___W9GIC {
  margin-left: 16px !important;
}

.Select-module__m-l-20___tHEYk {
  margin-left: 20px !important;
}

.Select-module__m-l-24___CFEAu {
  margin-left: 24px !important;
}

.Select-module__m-l-30___gZ021 {
  margin-left: 30px !important;
}

.Select-module__m-l-35___MaETt {
  margin-left: 35px !important;
}

.Select-module__m-l-40___MLuMB {
  margin-left: 40px !important;
}

.Select-module__m-r-8___kE_Kf {
  margin-right: 8px !important;
}

.Select-module__m-r-10___BxwXY {
  margin-right: 10px !important;
}

.Select-module__m-r-16___IVaLX {
  margin-right: 16px !important;
}

.Select-module__m-r-20___EPCAZ {
  margin-right: 20px !important;
}

.Select-module__m-r-24___X57gr {
  margin-right: 24px !important;
}

.Select-module__m-r-30___TZry6 {
  margin-right: 30px !important;
}

.Select-module__m-r-40___jmrtA {
  margin-right: 40px !important;
}

.Select-module__border-r-3___XFj_E {
  border-radius: 3px !important;
}

.Select-module__border-r-4___LHyq3 {
  border-radius: 4px !important;
}

.Select-module__border-r-6___LlOG_ {
  border-radius: 6px !important;
}

.Select-module__border-r-10___bvfJR {
  border-radius: 10px !important;
}

.Select-module__border-r-12___KBZoI {
  border-radius: 12px !important;
}

.Select-module__border-r-16___Kwe_g {
  border-radius: 16px !important;
}

.Select-module__border-r-50___gnRN3 {
  border-radius: 50% !important;
}

.Select-module__primary-border___ZtWKz {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Select-module__primary-border-b___FAf_H {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Select-module__primary-border-t___KVbDu {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Select-module__primary-border-l___d5_0W {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Select-module__primary-border-r___oO1eY {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Select-module__secondary-border___DuChv {
  border: 1px solid #637768;
}

.Select-module__secondary-border-b___DMQkW {
  border-bottom: 1px solid #637768;
}

.Select-module__secondary-border-t___nY8Qp {
  border-top: 1px solid #637768;
}

.Select-module__secondary-border-l___XciOz {
  border-left: 1px solid #637768;
}

.Select-module__secondary-border-r___qzWD9 {
  border-right: 1px solid #637768;
}

.Select-module__gap-0___smQ_w {
  gap: 0 !important;
}

.Select-module__gap-2___jadZV {
  gap: 2px !important;
}

.Select-module__gap-4___ra7C1 {
  gap: 4px !important;
}

.Select-module__gap-5___SknPJ {
  gap: 5px !important;
}

.Select-module__gap-6___A8XMu {
  gap: 6px !important;
}

.Select-module__gap-8___JnrwA {
  gap: 8px !important;
}

.Select-module__gap-10___EGGPS {
  gap: 10px !important;
}

.Select-module__gap-12___sX3jG {
  gap: 12px !important;
}

.Select-module__gap-14___ktbNR {
  gap: 14px !important;
}

.Select-module__gap-16___Q19Ro {
  gap: 16px !important;
}

.Select-module__gap-18___AHtn2 {
  gap: 18px !important;
}

.Select-module__gap-20___Q2_ta {
  gap: 20px !important;
}

.Select-module__gap-24___P4klZ {
  gap: 24px !important;
}

.Select-module__gap-26___TIbAb {
  gap: 26px !important;
}

.Select-module__gap-30___dGPLL {
  gap: 30px !important;
}

.Select-module__gap-32____Umpz {
  gap: 32px !important;
}

.Select-module__gap-40___wALgQ {
  gap: 40px !important;
}

.Select-module__gap-50___GBDSO {
  gap: 50px !important;
}

.Select-module__flex-1___gxVoV {
  flex: 1;
}

.Select-module__flex-none___ty67h {
  flex: none !important;
}

.Select-module__flex-column___z5tQD {
  display: flex;
  flex-direction: column !important;
}

.Select-module__flex-row___azfPu {
  display: flex;
  flex-direction: row !important;
}

.Select-module__vertically-centered___bVcqy {
  display: flex;
  align-items: center !important;
}

.Select-module__horizontally-centered___y4qrr {
  display: flex;
  justify-content: center !important;
}

.Select-module__horizontally-end___CIZfA {
  display: flex;
  justify-content: end !important;
}

.Select-module__vertically-start___HXdsu {
  display: flex;
  align-items: start !important;
}

.Select-module__space-between___bOh02 {
  display: flex;
  justify-content: space-between !important;
}

.Select-module__flex-wrap___hNHj2 {
  flex-wrap: wrap !important;
}

.Select-module__height-100___zVnYn {
  height: 100%;
}

.Select-module__width-50___vWSqX {
  width: 50% !important;
}

.Select-module__width-100___GH4EP {
  width: 100%;
}

.Select-module__cursor-pointer___yczo0 {
  cursor: pointer;
}

.Select-module__cursor-not-allowed___hhEGc {
  cursor: not-allowed !important;
}

.Select-module__absolute-centered___oS8Rx {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Select-module__absolute___FOiWM {
  position: absolute;
}

.Select-module__relative___E059R {
  position: relative;
}

.Select-module__fixed___IGRdL {
  position: fixed;
}

.Select-module__visible____Ar37 {
  opacity: 1;
}

.Select-module__invisible___v_OHe {
  opacity: 0;
}

.Select-module__col-90___TysfS {
  width: 90% !important;
}

.Select-module__col-auto___FsTH7 {
  width: auto !important;
}

.Select-module__medical-tabs____6798 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Select-module__medical-table-new___obmho {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Select-module__medical-table-new___obmho:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Select-module__medical-table-new___obmho::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Select-module__medical-table-new___obmho::-webkit-scrollbar-track {
  display: none;
}
.Select-module__medical-table-new___obmho.Select-module__no-pagination___FaWkW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Select-module__medical-table-new___obmho.Select-module__no-pagination___FaWkW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Select-module__medical-table-new___obmho.Select-module__no-pagination___FaWkW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Select-module__medical-table-new___obmho.Select-module__no-pagination___FaWkW::-webkit-scrollbar-track {
  display: none;
}

.Select-module__medical-table-empty___Ec7e2 {
  padding: 14px 40px !important;
}

.Select-module__icon-btn___lH5jU {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Select-module__search-icon___Uag24 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Select-module__disable-select___sbpwl {
  user-select: none;
}

.Select-module__break-word___wUjSL {
  word-break: break-word;
}

.Select-module__popup-clear-btn___SQvzX {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Select-module__scroll-m-b-20___qiGkT {
  scroll-margin-bottom: 20px;
}

.Select-module__container___SAYZZ {
  color: #375844;
}
.Select-module__container___SAYZZ .Select-module__label___PzaZC {
  color: #637768;
}
.Select-module__container___SAYZZ .Select-module__label___PzaZC.Select-module__withError___AbnSR {
  color: #db2828;
}
.Select-module__container___SAYZZ .Select-module__label___PzaZC.Select-module__disabled___KnHyP {
  cursor: not-allowed;
  opacity: 0.6;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW {
  cursor: pointer;
  padding: 10px;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW.Select-module__withError___AbnSR {
  color: #db2828;
  border: 1px solid #db2828;
  background-color: rgba(219, 40, 40, 0.1);
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW.Select-module__disabled___KnHyP {
  cursor: not-allowed;
  opacity: 0.6;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__icon___v5gIk {
  width: 18px;
  height: 18px;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__icon___v5gIk.Select-module__rotate___pciC7 {
  transform: rotate(180deg);
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__value___Dj6jd {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #375844;
  font-family: var(--font-family);
  text-align: left;
  flex: 1;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__value___Dj6jd.Select-module__withError___AbnSR {
  color: #db2828;
  opacity: 0.5 !important;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__value___Dj6jd.Select-module__opacity___mdESs {
  opacity: 0.3;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__value___Dj6jd .Select-module__multi___XS2Qu {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 75%;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__inputWrapper___ccasP {
  flex: 1;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__inputWrapper___ccasP .Select-module__input___uNwYi {
  border: none !important;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__inputWrapper___ccasP .Select-module__input___uNwYi > input {
  padding: 0 0 0 5px;
}
.Select-module__container___SAYZZ .Select-module__select___SRwuW .Select-module__upIcon___TGgVn {
  transform: rotate(180deg);
}
.Select-module__container___SAYZZ .Select-module__error___CzbZy {
  color: #db2828;
  display: inline-block;
  min-height: 15px;
}
.Select-module__container___SAYZZ .Select-module__paper___VDTCI {
  background-color: white;
  pointer-events: auto;
  overflow-y: scroll;
  max-height: 40vh;
  z-index: 100;
}
.Select-module__container___SAYZZ .Select-module__paper___VDTCI .Select-module__emptyPlaceholder___Hk23y {
  color: #375844;
  padding: 12px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Select/Select.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA5pBI;EACE,cAAA;AA8pBN;AA3pBI;EACE,mBAAA;EACA,YAAA;AA6pBN;AAzpBE;EACE,eAAA;EACA,aAAA;AA2pBJ;AAzpBI;EACE,cAAA;EACA,yBAAA;EACA,wCAAA;AA2pBN;AAxpBI;EACE,mBAAA;EACA,YAAA;AA0pBN;AAvpBI;EACE,WAAA;EACA,YAAA;AAypBN;AAvpBM;EACE,yBAAA;AAypBR;AArpBI;ECtCF,gBAAA;EACA,mBAAA;EACA,uBAAA;EDsCI,cAAA;EACA,+BEvCG;EFwCH,gBAAA;EACA,OAAA;AAypBN;AAvpBM;EACE,cAAA;EACA,uBAAA;AAypBR;AAtpBM;EACE,YAAA;AAwpBR;AArpBM;ECtDJ,gBAAA;EACA,mBAAA;EACA,uBAAA;EDsDM,cAAA;AAypBR;AArpBI;EACE,OAAA;AAupBN;AArpBM;EACE,uBAAA;AAupBR;AArpBQ;EACE,kBAAA;AAupBV;AAlpBI;EACE,yBAAA;AAopBN;AAhpBE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAkpBJ;AA/oBE;EACE,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAipBJ;AA/oBI;EACE,cAAA;EACA,aAAA;AAipBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n\n  .label {\n    color: get-color(greenNew, medium-dark);\n\n    &.withError {\n      color: get-color(redNew, medium);\n    }\n\n    &.disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n\n  .select {\n    cursor: pointer;\n    padding: 10px;\n\n    &.withError {\n      color: get-color(redNew, medium);\n      border: 1px solid get-color(redNew, medium);\n      background-color: get-color(redNew, light);\n    }\n\n    &.disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    .icon {\n      width: 18px;\n      height: 18px;\n\n      &.rotate {\n        transform: rotate(180deg);\n      }\n    }\n\n    .value {\n      @include clipped-text;\n      color: get-color(greenNew, dark);\n      font-family: $roboto;\n      text-align: left;\n      flex: 1;\n\n      &.withError {\n        color: get-color(redNew, medium);\n        opacity: 0.5 !important;\n      }\n\n      &.opacity {\n        opacity: 0.3;\n      }\n\n      .multi {\n        @include clipped-text;\n        max-width: 75%;\n      }\n    }\n\n    .inputWrapper {\n      flex: 1;\n\n      .input {\n        border: none !important;\n\n        & > input {\n          padding: 0 0 0 5px;\n        }\n      }\n    }\n\n    .upIcon {\n      transform: rotate(180deg);\n    }\n  }\n\n  .error {\n    color: get-color(redNew, medium);\n    display: inline-block;\n    min-height: 15px;\n  }\n\n  .paper {\n    background-color: get-color(white);\n    pointer-events: auto;\n    overflow-y: scroll;\n    max-height: 40vh;\n    z-index: 100;\n\n    .emptyPlaceholder {\n      color: get-color(greenNew, dark);\n      padding: 12px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Select-module__font-s-10___NZKoy`,
	"fontS12": `Select-module__font-s-12___a7FpE`,
	"fontS13": `Select-module__font-s-13___odC2j`,
	"fontS14": `Select-module__font-s-14___jaVYb`,
	"fontS15": `Select-module__font-s-15___oqo11`,
	"fontS16": `Select-module__font-s-16___U8Cx_`,
	"fontS18": `Select-module__font-s-18___vWhF4`,
	"fontS20": `Select-module__font-s-20___oBHmc`,
	"fontS22": `Select-module__font-s-22___IRuTh`,
	"fontS28": `Select-module__font-s-28___MTH6y`,
	"fontW400": `Select-module__font-w-400___mn0YZ`,
	"fontW500": `Select-module__font-w-500___LfKUQ`,
	"fontW600": `Select-module__font-w-600___TSBGl`,
	"fontW700": `Select-module__font-w-700___G8ML_`,
	"p5": `Select-module__p-5___XksNn`,
	"p12": `Select-module__p-12___seV6d`,
	"p16": `Select-module__p-16___XyNiq`,
	"p30": `Select-module__p-30___b2Lid`,
	"pB0": `Select-module__p-b-0___TKzyB`,
	"pB5": `Select-module__p-b-5___ymbg7`,
	"pB10": `Select-module__p-b-10___W8ujb`,
	"pB12": `Select-module__p-b-12___Hj9HV`,
	"pB16": `Select-module__p-b-16___eJcYR`,
	"pB18": `Select-module__p-b-18___bZOTt`,
	"pB20": `Select-module__p-b-20___P6JtO`,
	"pB25": `Select-module__p-b-25___Iy1qY`,
	"pB30": `Select-module__p-b-30___jpQJl`,
	"pB50": `Select-module__p-b-50___Yg25Z`,
	"pT0": `Select-module__p-t-0___WoirW`,
	"pT12": `Select-module__p-t-12___C8tL_`,
	"pT16": `Select-module__p-t-16___TQoxI`,
	"pT18": `Select-module__p-t-18___malJ4`,
	"pT20": `Select-module__p-t-20___jeOFc`,
	"pT30": `Select-module__p-t-30___ZvG1R`,
	"pT40": `Select-module__p-t-40___QXB76`,
	"pT50": `Select-module__p-t-50___X3RcM`,
	"pL20": `Select-module__p-l-20___Hwk_M`,
	"pL30": `Select-module__p-l-30___kT7fe`,
	"pL40": `Select-module__p-l-40___L5EVT`,
	"pR16": `Select-module__p-r-16___gzgVU`,
	"pR20": `Select-module__p-r-20___C3C09`,
	"pR30": `Select-module__p-r-30___ZbnDQ`,
	"pR50": `Select-module__p-r-50___oH9iK`,
	"pR60": `Select-module__p-r-60___wqSZ4`,
	"mB1": `Select-module__m-b-1___Pi158`,
	"mB2": `Select-module__m-b-2___g_izc`,
	"mB6": `Select-module__m-b-6___cTmcU`,
	"mB8": `Select-module__m-b-8___fRPEZ`,
	"mB10": `Select-module__m-b-10___arBXw`,
	"mB14": `Select-module__m-b-14___Z8Vcb`,
	"mB16": `Select-module__m-b-16___Do7tN`,
	"mB20": `Select-module__m-b-20___BnUDs`,
	"mB22": `Select-module__m-b-22___qdupk`,
	"mB24": `Select-module__m-b-24___cWXqq`,
	"mB30": `Select-module__m-b-30___ViFAO`,
	"mB32": `Select-module__m-b-32___HFWSZ`,
	"mB40": `Select-module__m-b-40___wfaIB`,
	"mT2": `Select-module__m-t-2___wSrLW`,
	"mT3": `Select-module__m-t-3___qd9SJ`,
	"mT4": `Select-module__m-t-4___sXtuy`,
	"mT5": `Select-module__m-t-5___BDSnI`,
	"mT8": `Select-module__m-t-8___jeOx2`,
	"mT10": `Select-module__m-t-10___NMVKA`,
	"mT15": `Select-module__m-t-15___DPqay`,
	"mT16": `Select-module__m-t-16___AbgxD`,
	"mT20": `Select-module__m-t-20___LmzIt`,
	"mT22": `Select-module__m-t-22___O_5yz`,
	"mT30": `Select-module__m-t-30____wm9g`,
	"mT32": `Select-module__m-t-32___r3hPI`,
	"mLAuto": `Select-module__m-l-auto___uFjoO`,
	"mL4": `Select-module__m-l-4___eJxsY`,
	"mL5": `Select-module__m-l-5___GGpHB`,
	"mL6": `Select-module__m-l-6___PS8QK`,
	"mL8": `Select-module__m-l-8___XuW1m`,
	"mL10": `Select-module__m-l-10___pgOD7`,
	"mL16": `Select-module__m-l-16___W9GIC`,
	"mL20": `Select-module__m-l-20___tHEYk`,
	"mL24": `Select-module__m-l-24___CFEAu`,
	"mL30": `Select-module__m-l-30___gZ021`,
	"mL35": `Select-module__m-l-35___MaETt`,
	"mL40": `Select-module__m-l-40___MLuMB`,
	"mR8": `Select-module__m-r-8___kE_Kf`,
	"mR10": `Select-module__m-r-10___BxwXY`,
	"mR16": `Select-module__m-r-16___IVaLX`,
	"mR20": `Select-module__m-r-20___EPCAZ`,
	"mR24": `Select-module__m-r-24___X57gr`,
	"mR30": `Select-module__m-r-30___TZry6`,
	"mR40": `Select-module__m-r-40___jmrtA`,
	"borderR3": `Select-module__border-r-3___XFj_E`,
	"borderR4": `Select-module__border-r-4___LHyq3`,
	"borderR6": `Select-module__border-r-6___LlOG_`,
	"borderR10": `Select-module__border-r-10___bvfJR`,
	"borderR12": `Select-module__border-r-12___KBZoI`,
	"borderR16": `Select-module__border-r-16___Kwe_g`,
	"borderR50": `Select-module__border-r-50___gnRN3`,
	"primaryBorder": `Select-module__primary-border___ZtWKz`,
	"primaryBorderB": `Select-module__primary-border-b___FAf_H`,
	"primaryBorderT": `Select-module__primary-border-t___KVbDu`,
	"primaryBorderL": `Select-module__primary-border-l___d5_0W`,
	"primaryBorderR": `Select-module__primary-border-r___oO1eY`,
	"secondaryBorder": `Select-module__secondary-border___DuChv`,
	"secondaryBorderB": `Select-module__secondary-border-b___DMQkW`,
	"secondaryBorderT": `Select-module__secondary-border-t___nY8Qp`,
	"secondaryBorderL": `Select-module__secondary-border-l___XciOz`,
	"secondaryBorderR": `Select-module__secondary-border-r___qzWD9`,
	"gap0": `Select-module__gap-0___smQ_w`,
	"gap2": `Select-module__gap-2___jadZV`,
	"gap4": `Select-module__gap-4___ra7C1`,
	"gap5": `Select-module__gap-5___SknPJ`,
	"gap6": `Select-module__gap-6___A8XMu`,
	"gap8": `Select-module__gap-8___JnrwA`,
	"gap10": `Select-module__gap-10___EGGPS`,
	"gap12": `Select-module__gap-12___sX3jG`,
	"gap14": `Select-module__gap-14___ktbNR`,
	"gap16": `Select-module__gap-16___Q19Ro`,
	"gap18": `Select-module__gap-18___AHtn2`,
	"gap20": `Select-module__gap-20___Q2_ta`,
	"gap24": `Select-module__gap-24___P4klZ`,
	"gap26": `Select-module__gap-26___TIbAb`,
	"gap30": `Select-module__gap-30___dGPLL`,
	"gap32": `Select-module__gap-32____Umpz`,
	"gap40": `Select-module__gap-40___wALgQ`,
	"gap50": `Select-module__gap-50___GBDSO`,
	"flex1": `Select-module__flex-1___gxVoV`,
	"flexNone": `Select-module__flex-none___ty67h`,
	"flexColumn": `Select-module__flex-column___z5tQD`,
	"flexRow": `Select-module__flex-row___azfPu`,
	"verticallyCentered": `Select-module__vertically-centered___bVcqy`,
	"horizontallyCentered": `Select-module__horizontally-centered___y4qrr`,
	"horizontallyEnd": `Select-module__horizontally-end___CIZfA`,
	"verticallyStart": `Select-module__vertically-start___HXdsu`,
	"spaceBetween": `Select-module__space-between___bOh02`,
	"flexWrap": `Select-module__flex-wrap___hNHj2`,
	"height100": `Select-module__height-100___zVnYn`,
	"width50": `Select-module__width-50___vWSqX`,
	"width100": `Select-module__width-100___GH4EP`,
	"cursorPointer": `Select-module__cursor-pointer___yczo0`,
	"cursorNotAllowed": `Select-module__cursor-not-allowed___hhEGc`,
	"absoluteCentered": `Select-module__absolute-centered___oS8Rx`,
	"absolute": `Select-module__absolute___FOiWM`,
	"relative": `Select-module__relative___E059R`,
	"fixed": `Select-module__fixed___IGRdL`,
	"visible": `Select-module__visible____Ar37`,
	"invisible": `Select-module__invisible___v_OHe`,
	"col90": `Select-module__col-90___TysfS`,
	"colAuto": `Select-module__col-auto___FsTH7`,
	"medicalTabs": `Select-module__medical-tabs____6798`,
	"medicalTableNew": `Select-module__medical-table-new___obmho`,
	"noPagination": `Select-module__no-pagination___FaWkW`,
	"medicalTableEmpty": `Select-module__medical-table-empty___Ec7e2`,
	"iconBtn": `Select-module__icon-btn___lH5jU`,
	"searchIcon": `Select-module__search-icon___Uag24`,
	"disableSelect": `Select-module__disable-select___sbpwl`,
	"breakWord": `Select-module__break-word___wUjSL`,
	"popupClearBtn": `Select-module__popup-clear-btn___SQvzX`,
	"scrollMB20": `Select-module__scroll-m-b-20___qiGkT`,
	"container": `Select-module__container___SAYZZ`,
	"label": `Select-module__label___PzaZC`,
	"withError": `Select-module__withError___AbnSR`,
	"disabled": `Select-module__disabled___KnHyP`,
	"select": `Select-module__select___SRwuW`,
	"icon": `Select-module__icon___v5gIk`,
	"rotate": `Select-module__rotate___pciC7`,
	"value": `Select-module__value___Dj6jd`,
	"opacity": `Select-module__opacity___mdESs`,
	"multi": `Select-module__multi___XS2Qu`,
	"inputWrapper": `Select-module__inputWrapper___ccasP`,
	"input": `Select-module__input___uNwYi`,
	"upIcon": `Select-module__upIcon___TGgVn`,
	"error": `Select-module__error___CzbZy`,
	"paper": `Select-module__paper___VDTCI`,
	"emptyPlaceholder": `Select-module__emptyPlaceholder___Hk23y`
};
module.exports = ___CSS_LOADER_EXPORT___;
